"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonEditModalButton = PersonEditModalButton;
exports.PersonAddNewModalButton = PersonAddNewModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../View/Modals/GeneralModalButtons");
const PersonsController_1 = require("../PersonsController");
const PersonModalBody_1 = require("./PersonModalBody");
const PersonValidationSchema_1 = require("./PersonValidationSchema");
const personsV2Helpers_1 = require("../personsV2Helpers");
/**
 * Domknięcie zapisu osoby danymi v2.
 *
 * UWAGA: oba payloady są dziś puste, więc `savePersonV2AccountAndProfile` pomija oba PUT-y
 * i to wywołanie NIE generuje żadnego żądania. Zostaje jako jedno miejsce podpięcia, gdy
 * formularz Osób dostanie pola konta (`systemRoleId`, `systemEmail` są w nim zakomentowane)
 * albo profilu (`headline`, `summary`) - wtedy trzeba tu wstawić realne payloady.
 *
 * Wiersz `PersonProfiles` nie jest już zakładany przy zapisie osoby: tworzą go leniwie
 * moduły profilu przy pierwszym wpisie (wykształcenie / doświadczenie / specjalizacja).
 */
async function savePersonV2Data(person) {
    if (!person?.id)
        return [];
    const result = await (0, personsV2Helpers_1.savePersonV2AccountAndProfile)(person.id, {}, {}, "Persons");
    return result.errors;
}
function PersonEditModalButton({ modalProps: { onEdit, initialData }, }) {
    async function handleEdit(editedObject) {
        const errors = await savePersonV2Data(editedObject);
        // Lista dostaje dane legacy niezależnie od wyniku v2 - one już są w bazie.
        onEdit(editedObject);
        // Dopiero teraz błąd: modal zostaje otwarty i pokazuje, czego NIE zapisał.
        (0, personsV2Helpers_1.throwOnSaveErrors)(errors);
    }
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: handleEdit,
            ModalBodyComponent: PersonModalBody_1.PersonModalBody,
            modalTitle: "Edycja danych osoby",
            repository: PersonsController_1.personsRepository,
            initialData: initialData,
            makeValidationSchema: PersonValidationSchema_1.makePersonValidationSchema,
            // PersonModalBody używa InlineCreateDrawer — modal musi puścić focus do panelu
            enforceFocus: false,
        }, buttonProps: {
            buttonVariant: "outline-success",
        } }));
}
function PersonAddNewModalButton({ modalProps: { onAddNew } }) {
    async function handleAddNew(newObject) {
        const errors = await savePersonV2Data(newObject);
        onAddNew(newObject);
        (0, personsV2Helpers_1.throwOnSaveErrors)(errors);
    }
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: handleAddNew,
            ModalBodyComponent: PersonModalBody_1.PersonModalBody,
            modalTitle: "Dodaj osobę",
            repository: PersonsController_1.personsRepository,
            makeValidationSchema: PersonValidationSchema_1.makePersonValidationSchema,
            // PersonModalBody używa InlineCreateDrawer — modal musi puścić focus do panelu
            enforceFocus: false,
        }, buttonProps: {
            buttonCaption: "Dodaj osobę",
            buttonVariant: "outline-success",
        } }));
}
